var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.checkRoles(_vm.roles.admins)),expression:"$auth.checkRoles(roles.admins)"}],staticClass:"text-center greet-user mb-5",attrs:{"slot":"no-body","title":_vm.$t('Decarbonization.Admin.Title')},slot:"no-body"},[_c('menu-control',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }